import React from 'react';

import { Header, tableBetHistoryStore } from '@pascal/pascal-core';
import { GameControllerTypes } from '@pascal/pascal-core/table-line/t_types/enums/GameControllerTypes';

import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { observer } from 'mobx-react-lite';
import { HelpPopup } from '../../components/helpPopup';

import gameLogo from '../../assets/images/baccarat/bacarat-logo.png';
import { BetHistoryWr } from '../betHistory';
import { SettingsContainer } from '../settingsContainer';

export const HeaderWr = observer(() => {
  const { setSelectedHistoryRow, selectedHistoryRow } = tableBetHistoryStore;
  const { currencySymbolOrCode } = userInfoStore;

  return (
    <Header
      isShowSound={false}
      isShowFairness={false}
      isShowFullScreen={false}
      lobbyPath={null}
      logoSrc={gameLogo}
      currencyCode={currencySymbolOrCode}
      selectedHistoryRow={selectedHistoryRow}
      setSelectedHistoryRow={setSelectedHistoryRow}
      gameControllerComponents={{
        [GameControllerTypes.Help]: <HelpPopup />,
        [GameControllerTypes.History]: <BetHistoryWr />,
        [GameControllerTypes.Settings]: <SettingsContainer />,
      }}
    />
  );
});
